import { createUseStyles } from "react-jss";
import { ChoiceListDisplayType } from "../../../models/enums/ChoiceListDisplayType";
import { backgroundless, getSpacing } from "../../../theme/Mixins";

export default createUseStyles({
    choiceList: {
        composes: "choice-list",
        display: ({ displayType }) =>
            displayType === ChoiceListDisplayType.Horizontal ||
            displayType === ChoiceListDisplayType.HorizontalColumns
                ? "flex"
                : null,
        flexWrap: "wrap",
        alignItems: "flex-start",
    },
    choiceListTableHorizontal: {
        composes: "choice-list--table--horizontal",
        display: "flex",
        flexWrap: "wrap",
    },
    choiceListTableVertical: {
        composes: "choice-list--table--vertical",
    },
    choiceListGrid: {
        composes: "choice-list--grid",
        display: "grid",
        gridAutoFlow: ({ displayType }) =>
            displayType === ChoiceListDisplayType.VerticalColumns ? "column" : null,
        gridGap: ({ theme }) => (backgroundless(theme) ? 0 : getSpacing(theme, theme.ChoiceSpacing, theme.QuestionSpacing?.WithinComponents) / 2),
        gridTemplateColumns: ({ numberOfColumns }) => `repeat(${numberOfColumns}, 1fr)`,
        gridTemplateRows: ({ numberOfRows }) => `repeat(${numberOfRows}, auto)`,
        overflowWrap: "anywhere",
        "&>.choice": {
            margin: 0,
            minWidth: 125,
        },
        "& .choice__container": {
            alignItems: "start",
            minWidth: 90,
        },
    },
    checkBoxAlignment: {
        "& .choice__container": {
            flexDirection: ({ theme }) =>
                theme.CheckBoxIconAlignment === "right" ? "row-reverse" : "row",
        },
    },
    radioIconAlignment: {
        "& .choice__container": {
            flexDirection: ({ theme }) =>
                theme.RadioIconAlignment === "right" ? "row-reverse" : "row",
        },
    },
});
